// extracted by mini-css-extract-plugin
export default {"orderPageContainer":"orderPage_orderPageContainer__QC70O"};